import React, { ReactNode } from 'react'

import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'

import { PostHogPageView } from './PostHogPageView'

export const AnalyticsProvider = ({ children }: { children: ReactNode }) => {
  return (
    <PostHogProvider {...{ client: posthog }}>
      <PostHogPageView />
      {children}
    </PostHogProvider>
  )
}
